import { render, staticRenderFns } from "./patientPortalChangeInfoDialog.vue?vue&type=template&id=0f0b2885&"
import script from "./patientPortalChangeInfoDialog.vue?vue&type=script&lang=js&"
export * from "./patientPortalChangeInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports